var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-center p-3 shadow-sm"},[_c('p',{staticClass:"text-gray-500 mb-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"h2 text-black font-normal"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }